import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _59e264f7 = () => interopDefault(import('../../../pages/services/index.vue' /* webpackChunkName: "pages/services/index" */))
const _35bffa13 = () => interopDefault(import('../../../pages/projects/index.vue' /* webpackChunkName: "pages/projects/index" */))
const _98173ca8 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _582bc3af = () => interopDefault(import('../../../pages/services/_slug.vue' /* webpackChunkName: "pages/services/_slug" */))
const _340958cb = () => interopDefault(import('../../../pages/projects/_slug.vue' /* webpackChunkName: "pages/projects/_slug" */))
const _428d77a8 = () => interopDefault(import('../../../pages/stories/_slug.vue' /* webpackChunkName: "pages/stories/_slug" */))
const _5022c88e = () => interopDefault(import('../../../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/programs",
    component: _59e264f7,
    name: "services___en"
  }, {
    path: "/projects",
    component: _35bffa13,
    name: "projects___en"
  }, {
    path: "/",
    component: _98173ca8,
    name: "index___en"
  }, {
    path: "/programs/:slug",
    component: _582bc3af,
    name: "services-slug___en"
  }, {
    path: "/projects/:slug",
    component: _340958cb,
    name: "projects-slug___en"
  }, {
    path: "/stories/:slug",
    component: _428d77a8,
    name: "stories-slug___en"
  }, {
    path: "/*",
    component: _5022c88e,
    name: "all___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
